import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { CurrencyPipe } from '../../filters/currency.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../loader-overlay/loader-overlay.component';
import { AvatarComponent } from '../avatar/avatar.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ProfileRestServices from '../../services/profile-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import DialogServices from '../../services/dialog.service';
import Toast from '../../services/toast.service';
import BookingsService from '../../services/bookings.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalBookingDeclineComponent } from '../modal-booking-decline/modal-booking-decline.component';
import { ModalBookingRescheduleComponent } from '../modal-booking-reschedule/modal-booking-reschedule.component';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';
import RestService from "../../services/core-rest.service";

@Component({
	standalone: true,
	selector: 'item-booking-info',
	templateUrl: './item-booking-info.component.html',
	imports: [ CommonModule, PanelDirective, LowerCasePipe, CurrencyPipe, TranslatePipe, LoaderOverlayComponent, AvatarComponent, FormsModule ]
})
export class ItemBookingInfoComponent implements OnInit, OnDestroy {
	private profileRestServices: ProfileRestServices = inject(ProfileRestServices);
	private restService: RestService = inject(RestService);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private toast: Toast = inject(Toast);
	private bookingsService: BookingsService = inject(BookingsService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() booking: any;
	@Input() showPrescription: any;
	@Output() bookingChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() original: any;
	@Output() originalChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() isAlt: any | undefined;
	@Input() onSave: any | undefined;
	@Output() onSaveChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.initialize();
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this,
				this.config.getBroadcastConfig().Bookings.RESCHEDULE + this.vm.booking.id,
				(e, data) => {
					this.handleBookingTimeChange(e, data);
				})
		);
		
		this.vm.showNotes = this.showNotes;
		this.vm.copyReservationLink = this.copyReservationLink;
		this.vm.handleBookingCancel = this.handleBookingCancel;
		this.vm.handleReservedBookingCancel = this.handleReservedBookingCancel;
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.handleRescheduleModalOpen = this.handleRescheduleModalOpen;
		this.vm.getPrescriptionDescription = this.getPrescriptionDescription;
		this.vm.isTherapyFundBooking = this.isTherapyFundBooking;
		this.vm.sendTherapyFundNotes = this.sendTherapyFundNotes;
		this.vm.isSentToTherapyFund = this.isSentToTherapyFund;
		this.vm.handleQuestionnaireSend = this.handleQuestionnaireSend;
		if (this.vm.user.businessUserType === 'SERVICE_PROVIDER') {
			var currentBookingId = undefined;
			this.watcher = this.angularHelperService.createInterval(() => {
				if (this.vm.booking.id !== currentBookingId) {
					currentBookingId = this.vm.booking.id;
					this.getExtraInfo();
				}
			}, 300);
		}
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	initialize() {
		if (!this.vm.booking) return;
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.isWeightLossSupportedDoctor = this.vm.user?.service?.weightLossServiceSupported;
		this.vm.uid = 'bi-' + Date.now();
		this.vm.prescriptionId = this.vm.booking.bookingInstantRequest
			&& this.vm.booking.bookingInstantRequest.prescriptionRequest
			&& this.vm.booking.bookingInstantRequest.prescriptionRequest.id;
		this.vm.isPrescription = !!this.vm.prescriptionId;
		this.vm.isWeightLossPrescription = !this.vm.prescriptionId && this.vm.showPrescription;
		this.vm.isReservedBooking = this.vm.booking.status === 'RESERVED';
		this.vm.dosageInstructionsMaxLength = 1000;
		
		this.updateIsUpcoming();
		this.handleBookingDatesUpdate();
		
		var promises: Array<any> = [this.getBookingDetails()];
		if (this.vm.isPrescription) promises.push(this.getRequestDetails());
		if (this.vm.isWeightLossPrescription) promises.push(this.getRequestDetails());
		promises.push(this.getAvailableSurveys());
		this.vm.loaderTimeout = this.angularHelperService.createTimer(
			() => { this.vm.loading = true; }, this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		
		this.angularHelperService.getPromise().all(promises).then(() => {
			this.vm.isHomeVisit = this.vm.booking.service.subcategory === 'HOME_VISITS';
			this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
			if (this.vm.loading) this.angularHelperService.createTimer(() => {
				this.vm.loading = false;
				this.vm.initialized = true;
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			this.vm.initialized = true;
		});
	}
	
	handleBookingTimeChange(e, data) {
		if (!data || data.id !== this.vm.booking.id) return;
		if (data.scheduledStart) this.vm.booking.scheduledStart = new Date(data.scheduledStart);
		if (data.scheduledEnd) this.vm.booking.scheduledEnd = new Date(data.scheduledEnd);
		this.handleBookingDatesUpdate();
	}
	
	handleBookingDatesUpdate() {
		this.vm.booking.date = moment(this.vm.booking.scheduledStart).locale(this.vm.user.deviceLanguage.slice(0, 2)).format('dddd, DD.MM.YY');
		this.vm.booking.start = moment(this.vm.booking.scheduledStart).format('HH:mm');
		this.vm.booking.end = moment(this.vm.booking.scheduledEnd).format('HH:mm');
		var duration = moment(this.vm.booking.scheduledEnd).diff(moment(this.vm.booking.scheduledStart));
		this.vm.booking.duration = moment.duration(duration).asMinutes();
	}
	
	isUpcoming() {
		return (this.vm.isPrescription || this.vm.isWeightLossPrescription || new Date(this.vm.booking.scheduledStart) > new Date())
			&& this.vm.booking.status !== 'DECLINED' && this.vm.booking.status !== 'COMPLETED' && this.vm.booking.status !== 'RESERVED';
	}
	
	updateIsUpcoming() {
		this.vm.isUpcomingStatus = this.isUpcoming();
	}
	
	getPrescriptionDescription() {
		if (this.vm.booking.bookingInstantRequest.prescriptionRequest.prescription) {
			var drugName: any = this.vm.booking.bookingInstantRequest.prescriptionRequest.prescription.drugName
				|| this.vm.booking.bookingInstantRequest.prescriptionRequest.prescription.ingredientName;
			return this.vm.booking.bookingInstantRequest.prescriptionRequest.prescription.prescriptionNumber + ', ' + drugName;
		}
		if (this.vm.booking.bookingInstantRequest.prescriptionRequest.drug
			&& this.vm.booking.bookingInstantRequest.prescriptionRequest.drug.name) {
			return this.vm.booking.bookingInstantRequest.prescriptionRequest.drug.name
				+ (this.vm.booking.bookingInstantRequest.prescriptionRequest.drug.amount
					? (' ' + this.vm.booking.bookingInstantRequest.prescriptionRequest.drug.amount) : '');
		}
		return this.vm.booking.bookingInstantRequest.prescriptionRequest.drugIngredient.name;
	}
	
	copyReservationLink($event) {
		$event.preventDefault();
		// create temp element
		var copyElement: any = document.createElement("span");
		copyElement.appendChild(document.createTextNode(this.vm.booking.reservationLink));
		copyElement.id = 'tempCopyToClipboard';
		this.angularHelperService.element(document.body.append(copyElement));
		
		// select the text
		var range: any = document.createRange();
		range.selectNode(copyElement);
		var _window: any = window;
		_window.getSelection().removeAllRanges();
		_window.getSelection().addRange(range);
		
		// copy & cleanup
		document.execCommand('copy');
		_window.getSelection().removeAllRanges();
		copyElement.remove();
	}
	
	handleBookingCancel = () => {
		if (!this.isUpcoming()) return;
		if (!this.vm.booking || this.vm.booking && this.vm.booking.handleInProgress) return;
		this.vm.booking.handleInProgress = true;
		
		var dialog = this.dialogServices.show({
			controller: ModalBookingDeclineComponent,
			booking: this.vm.booking
		});
		dialog.afterClosed().subscribe(() => {
//			if (this.angularMaterialHelperService.getMaterialDialog().cancel) this.dialogRef.close();
			this.vm.booking.status = 'DECLINED';
			this.updateIsUpcoming();
			if (this.angularRoutingHelperService.getCurrentPath() === 'schedule') {
				this.angularHelperService.getWindow().location.reload();
			}
		}, () => {
			this.vm.booking.handleInProgress = false;
		});
	}
	
	handleReservedBookingCancel() {
		if (!this.vm.isReservedBooking) return;
		if (!this.vm.booking || this.vm.booking && this.vm.booking.handleInProgress) return;
		this.vm.booking.handleInProgress = true;
		this.serviceRestServices.removeReservedTimeSlot({ bookingId: this.vm.booking.id }, (res) => {
//			if (this.angularMaterialHelperService.getMaterialDialog().cancel) this.dialogRef.close();
			window.location.reload();
		}, (err) => {
			console.log(err);
		});
	}
	
	getBookingDetails() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.serviceRestServices.getBookingDetails({ bookingId: this.vm.booking.id }, (res)  => {
			var bookingConsents: any = res.consents || {};
			var generalConsents: any = res.user.consents || {};
			this.vm.notesAllowed = this.isTherapyFundBooking() ||
				(bookingConsents.dataProcessingAccepted 
					&& bookingConsents.dataStorageTimeAccepted 
					&& bookingConsents.dataSharingAccepted);
			if (res.notes) this.vm.notes = res.notes.notes;
			this.vm.booking.user = res.user;
			this.vm.booking.service = res.service;
			
			deferred.resolve();
		}, (err) => {
			deferred.reject(err);
		});
		
		return deferred.promise;
	}
	
	getExtraInfo() {
		if (this.vm.booking && !this.vm.booking.extraInfo) {
			this.profileRestServices.getExtraInfo({
				userId: this.vm.booking.user.id
			}).then((extraInfo) => {
				this.vm.booking.extraInfo = extraInfo;
			}).catch((error) => {
				console.log(error);
			});
		}
	}
	
	isTherapyFundBooking() {
		return this.vm.booking && this.vm.booking.businessWallet && this.vm.booking.businessWallet.walletType === 'THERAPY_FUND';
	}
	
	isSentToTherapyFund() {
		return this.vm.booking && this.vm.booking.therapyFundSendDate;
	}
	
	getRequestDetails() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.serviceRestServices.getBookingWithRequestDetails({ bookingId: this.vm.booking.id },
			(res) => {
				this.vm.booking.bookingInstantRequest = res.bookingInstantRequest;
				if (res.bookingInstantRequest != null) {
					this.vm.prescriptionNumber = this.vm.booking.bookingInstantRequest.prescriptionRequest
						&& this.vm.booking.bookingInstantRequest.prescriptionRequest.prescriptionNumber;
				}
				this.vm.weightLossPrescriptionNumber = this.vm.booking.bookingPrescription &&
					this.vm.booking.bookingPrescription.prescriptionNumber;
				deferred.resolve(res);
			},
			() => {
				deferred.reject();
			}
		);
		
		return deferred.promise;
	}

	getAvailableSurveys() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.restService.getQuestionnaireSearch({ userId: this.vm.booking.user.id })
			.then((result) => {
				deferred.resolve(result);
				this.vm.questionnaires = result.questionnaires;
				this.vm.selectedLang = result.customerLanguage;
			})
			.catch((err) => {
				deferred.reject();
			});
		return deferred.promise;
	}
	
	showNotes() {
		if (!this.vm.notesAllowed) {
			var toastMessage = this.angularFilterHelperService.translate('Services.Other.Notes_Disabled');
			this.toast.showAsync(toastMessage, this.angularFilterHelperService.translate('Common.Got_It'));
			return;
		}
		this.vm.notesVisible = true;
	}
	
	handleFormSubmit(mainForm: any, withNotification) {
		if (this.vm.isPrescription) {
			this.handlePrescriptionSubmit(mainForm);
		} else if(this.vm.isWeightLossPrescription) {
			this.handleWeightLossPrescriptionSubmit(mainForm, withNotification);
		} else {
			this.handleNotesSubmit();
		}
	}
	
	handlePrescriptionSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		
		if (!this.vm.prescriptionId) {
			if (typeof this.vm.onSave === 'function') this.vm.onSave();
			return;
		}
		
		this.vm.loading = true;
		var data: any = {
			id: this.vm.prescriptionId,
			prescriptionNumber: this.vm.prescriptionNumber,
			dosageInstructions: this.vm.dosageInstructions,
		};

		this.serviceRestServices.updatePrescription(data,
			() => {
				this.handlePrescriptionSubmitSuccess();
			},
			(err) => {
				this.handleSubmitError(err);
			});
	}

	handleWeightLossPrescriptionSubmit(mainForm: any, withNotification) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;

		if (!this.vm.isWeightLossPrescription) {
			if (typeof this.vm.onSave === 'function') this.vm.onSave();
			return;
		}

		this.vm.loading = true;
		var data: any = {
			prescriptionNumber: this.vm.weightLossPrescriptionNumberInput,
			guidelines: this.vm.guidelines,
			withNotification: withNotification,
			booking: this.vm.booking
		};


		this.serviceRestServices.saveBookingPrescription(data,
			() => {
				this.handlePrescriptionSubmitSuccess();
				this.updateIsUpcoming();
			},
			(err) => {
				this.handleSubmitError(err);
			});

	}

	handleNotesSubmit() {
		if (!this.vm.notesAllowed) {
			if (typeof this.vm.onSave === 'function') this.vm.onSave();
			return;
		}
		
		this.vm.loading = true;
		var data: any = {
			booking: { id: this.vm.booking.id },
			user: { id: this.vm.booking.user.id }
		};
		if (this.vm.notes && this.vm.notes.trim()) data.notes = this.angularHelperService.copy(this.vm.notes.trim());
		
		this.serviceRestServices.saveAppointmentNotes(data,
			() => {
				this.handleSubmitSuccess();
			},
			(err) => {
				this.handleSubmitError(err);
			});
	}

	handleQuestionnaireSend() {
		this.vm.loading = true;
		this.submitQuestionnaireToChat();
	}

	submitQuestionnaireToChat() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		let questionnaire = this.vm.questionnaires.find(q => q.codeName === "DOM-PRE-BOOKING");

		var params = { userId: this.vm.booking.user.id, language: this.vm.selectedLang };
		this.restService.saveQuestionnaireShare(params, questionnaire)
			.then((chatPosts) => {
				deferred.resolve(chatPosts);
				const metadata = chatPosts
					.flatMap(post => post.metadatas || [])
					.find(item => item.type === 'QUESTIONNAIRE_REQUEST');
				if (metadata) {
					try {
						this.vm.metadata = JSON.parse(metadata.metadata);
					} catch (e) {
						console.error(e);
						return deferred.reject(e);
					}
					this.serviceRestServices.sendQuestionnaire({ userId: this.vm.booking.user.id, requestId: this.vm.metadata.id})
						.then(() => this.handleSubmitSuccess())
						.catch((err) => this.handleSubmitError(err));
				}
			})
			.catch((err) => {
				console.error(err);
				this.handleSubmitError(err);
				deferred.reject(err);
			});
		return deferred.promise;
	}

	sendTherapyFundNotes() {
		if (!this.vm.notesAllowed || !this.vm.notes || !this.vm.notes.trim()) {
			return;
		}
		
		this.vm.loading = true;
		var data: any = {
			booking: { id: this.vm.booking.id },
			user: { id: this.vm.booking.user.id }
		};
		if (this.vm.notes && this.vm.notes.trim()) data.notes = this.angularHelperService.copy(this.vm.notes.trim());
		
		this.serviceRestServices.submitNotesToTherapyFund(data,
			() => {
				if (this.vm.original) {
					this.vm.original.therapyFundSendDate = new Date();
				}
				this.handleSubmitSuccess();
			},
			(err) => {
				this.handleSubmitError(err);
			});
	}
	
	handlePrescriptionSubmitSuccess() {
		this.handleSubmitSuccess();
		this.bookingsService.fetchBookings({ status: 'CONFIRMED' });
	}
	
	handleSubmitSuccess() {
		if (typeof this.vm.onSave === 'function') this.vm.onSave();
		this.angularHelperService.createTimer(()  => { this.vm.loading = false; }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	}
	
	handleSubmitError(err) {
		console.error(err);
		this.angularHelperService.createTimer(() => { this.vm.loading = false; }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	}
	
	handleRescheduleModalOpen() {
		if (!this.isUpcoming()) return;
		if (!this.vm.booking) return;
		
		var dialog = this.dialogServices.show({
			controller: ModalBookingRescheduleComponent,
			booking: this.vm.booking
		})
		dialog.afterClosed().subscribe(() => {
			this.updateIsUpcoming();
		});
	}
	
}